import { defineEffect } from '../../../core/effect';
import { damageSpec } from '../fx/damage';

/** 効果ダメージ（Issue #589。状況は共通側の `editorPorts/duelSituations/damage.js` が決め、絵の組み立ては `../fx/damage.js`） */
export default defineEffect({ situation: 'damage_effect', role: 'effect', ...damageSpec(false) }, 'damage_effect_effect.js');
